import React from 'react'
import InstallationCodeLink from "../../../InstallationCode/InstallationCodeLink"

import Table, { TableRow } from '../../../../../../common/components/molecule/Table/Table'
import { Minigrid } from '../../../../types/minigridtypes'
import ConfirmationModal from '../../../../../../common/components/atom/ConfirmationModal/ConfirmationModal';


/** Liste des minigrids. Le détail énergie (Solaire / Batterie / Réseau / Groupe) se fait depuis la fiche minigrid → Dashboard en direct (cartes cliquables). */
export interface MinigridListViewProps {

    minigridList?: Minigrid[] | null;
    deleteMinigridHandler?: (minigridId: string) => void;
    updateMinigridHandler?: (minigridId: string) => void;
    goToEditMinigrid?: (minigridId: string) => void;
    goToSingleMinigrid?: (minigridId: string) => void;
    isLoading?: boolean;

}

function MinigridListView({ minigridList, deleteMinigridHandler, updateMinigridHandler, goToEditMinigrid, goToSingleMinigrid, isLoading}: MinigridListViewProps) {
    const [modalIsOpen, setModalIsOpen] = React.useState(false)
    const [minigridSelected, setMinigridSelected] = React.useState<Minigrid | null>(null)

    const onDelete = (minigrid: Minigrid) => {

       if (deleteMinigridHandler){
        setModalIsOpen(true)
        setMinigridSelected(minigrid)
       }

    }

    const onClick = (minigridId : string ) => {

        if(goToSingleMinigrid){
            goToSingleMinigrid(minigridId)
        }
    }


    const minigridListFormated = minigridList?.reduce<TableRow[]>((acc, minigrid) => {

        acc.push({
            data: [minigrid.minigrid_name, <InstallationCodeLink key={`code-${minigrid.minigrid_id}`} code={minigrid.minigrid_installation_code} emptyLabel="—" />, minigrid.minigrid_type, minigrid.minigrid_description.length > 40 ? minigrid.minigrid_description.slice(0, 40) + '...' : minigrid.minigrid_description],
            id: minigrid.minigrid_id,
            onDelete: deleteMinigridHandler ? () => {onDelete(minigrid)} : undefined,
            onEdit: updateMinigridHandler ? () => {updateMinigridHandler(minigrid.minigrid_id)} : undefined
        })
        return acc
    },[])

  return (
    <>
      <ConfirmationModal
        isOpen={modalIsOpen}
        type="danger"
        title="Attention"
        message={`Voulez-vous vraiment supprimer le minigrid ${minigridSelected?.minigrid_name}?`}
        confirmText="Supprimer"
        cancelText="Annuler"
        onConfirm={() => {
          if (deleteMinigridHandler && minigridSelected) {
            deleteMinigridHandler(minigridSelected.minigrid_id)
          }
          setModalIsOpen(false)
        }}
        onCancel={() => setModalIsOpen(false)}
      />
    <Table
    headerTitle={['Nom Minigrid', 'Code installation', 'Type', 'Description']}
    bodyData={minigridListFormated}
    onRowClick={(row) => onClick(row.id)}
    onEditRow={goToEditMinigrid ? (row) => goToEditMinigrid(row.id) : undefined}
    isLoading={isLoading}
    emptyMessage='Aucun minigrid trouvée'
 />
 </>
  )
}



export default MinigridListView
